/**
 *  UI-REFACTORED
 *    FROM --> ./legacy-web/src/main/js/js/aa/receipts/receiptInformation.js
 *    TO   --> ./legacy-web/src/main/assets/js/receipts/receipt-information.js
 **/

/* global KeyValueObject:true */
/* global waTealiumUtils:true */
/* global onMessage:true */

AAcom('browserdetect', 'utilities', 'commonsetup', 'ajax', 'aaDatePicker', function(AAUI) {
    AAUI.inputCharChecker = function() {
        var self = {};

        self.charChecker = function(element) {
            var isNumber = function(event) {
                var character = event.keycode ? event.keycode : event.charCode;
                if(character >= 48 && character <= 57 || character === 0) {
                    return true;
                }
            }

            var isLetter = function(event) {
                var character = event.keycode ? event.keycode : event.charCode;
                if(!isNumber(event) || character === 0) {
                    return true;
                }
            }

            $j(element).on('keypress', function(event) {
                var isNumeric = $j(element).data('numeric') == true ? isNumber(event) : isLetter(event);
                if(isNumeric) {
                    return isNumeric;
                }
                return false;
            });
        };

        return self;
    };

    AAUI.retrieveReceipts = function() {
        var self = {};

        self.receipts = {};
        self.wifiReceipts = {};

        self.webAnalyticsData = [];

        self.addToWebAnalytics = function(key, value) {
            self.webAnalyticsData[self.webAnalyticsData.length] = new KeyValueObject(key, value);
        };

        self.reportToWebAnalytics = function() {
            waTealiumUtils.reportEvent(self.webAnalyticsData, "view");
            self.webAnalyticsData = [];
        };

        self.init = function() {
            AAUI.onClick('#receiptsSearchSubmit', function(e) {
                e.preventDefault();
                self.getResults('receiptsSearchInputForm');

            });

            AAUI.onChange('#receiptsSearchInputForm input', function(e) {
                $j('#flightNumberRequired').val(false);
            });

            AAUI.onClick('.showReceipt', function(e) {
                e.preventDefault();
                var templateFrom = $j(this).data('template-id');
                var index = $j(this).data('receiptIndex');
                var data = $j(this).data('receipt');
                data.index = index;

                self.getReceipt(templateFrom, data);
                $j('#aa-wifiReceiptResults').hide();
                $j('#aa-receiptInformation').focus();
            });

            AAUI.onClick('.showWifiReceipt', function(e) {
                e.preventDefault();
                var templateFrom = $j(this).data('template-id');
                var index = $j(this).data('wifiIndex');
                var data = $j(this).data('wifi');
                data.index = index;

                self.getWifiReceipt(templateFrom, data);
                $j('#aa-receiptResults').hide();
                $j('#aa-wifiReceiptInformation').focus();
            });

            AAUI.onClick('#backButton', function(e) {
                e.preventDefault();
                var receiptResults = '#aa-receiptResults';
                var wifiReceiptResults = '#aa-wifiReceiptResults';
                var itemizedReceipt = '#aa-receiptInformation';
                var receiptIndex = $j(this).data('receiptIndex');
                self.toggleAllReceiptViews(itemizedReceipt, receiptResults, wifiReceiptResults);
                $j('#receipt_' + receiptIndex).focus();

            });

            AAUI.onClick('#wifiBackButton', function(e) {
                e.preventDefault();
                var receiptResults = '#aa-receiptResults';
                var wifiReceiptResults = '#aa-wifiReceiptResults';
                var itemizedWifiReceipt = '#aa-wifiReceiptInformation';
                var wifiReceiptIndex = $j(this).data('wifiIndex');
                self.toggleAllReceiptViews(itemizedWifiReceipt, receiptResults, wifiReceiptResults);
                $j('#wifiReceipt_' + wifiReceiptIndex).focus();

            });

            AAUI.onClick('.aa-printPreview', function(e) {
                e.preventDefault();
                AAUI.genericManualPopup($j(this).attr('href'), $j(this).attr('title'), 'medium');
            });

            AAUI.onClick('.aa-wifiPrintPreview', function(e) {
                e.preventDefault();
                AAUI.genericManualPopup($j(this).attr('href'), $j(this).attr('title'), 'medium');
            });
        };

        self.toggleViews = function(hideView, revealView) {
            var hideView = $j(hideView);
            var revealView = $j(revealView);

            if(hideView.is(':visible')) {
                hideView.hide();
                revealView.show();
            }else{
                revealView.hide();
                hideView.show();
            }
        };

        self.toggleAllReceiptViews = function(hideView, receiptResults, wifiReceiptResults) {
            var hideView = $j(hideView);
            var receiptResults = $j(receiptResults);
            var wifiReceiptResults = $j(wifiReceiptResults);

            hideView.hide();
            if(self.receipts.length) {
            	receiptResults.show();
            }
            if(self.wifiReceipts.length) {
            	wifiReceiptResults.show();
            }
        };

        self.handlebarWorker = function() {
            var templates = {
                addHandleBarsTemplate: function(templates) {
                    templates.forEach(function(template) {
                        handlebarWorker.postMessage({
                            action: 'addTemplate',
                            key: template.name,
                            data: $j('#' + template.name + '-template').html()
                        });
                    });
                },
                parseHandlebarsTemplate: function(templates) {
                    templates.forEach(function(template) {
                        handlebarWorker.postMessage({
                            action: 'parseTemplate',
                            key: template.name,
                            data: template.data,
                            templateContainer: 'aa-' + template.name
                        });
                    });
                }
            };

            if(window.Worker) {
                var handlebarWorker = new Worker('/assets/js/webworker/handlebar-worker.min.js');
                handlebarWorker.onmessage = function(e) {
                    $j('#' + e.data.templateContainer).empty().html(e.data.html);
                };

                templates.addHandleBarsTemplate([
                    {
                        name: 'receiptResults'
                    },
                    {
                        name: 'wifiReceiptResults'
                    },
                    {
                        name: 'receiptInformation'
                    },
                    {
                        name: 'wifiReceiptInformation'
                    }
                ]);
            }else{
                $j.getScript('/assets/js/webworker/handlebar-no-worker.min.js', function(data, textStatus, jqxhr) {
                    handlebarWorker = {
                        postMessage: onMessage
                    };

                    templates.addHandleBarsTemplate([
                        {
                            name: 'receiptResults'
                        },
                        {
                            name: 'wifiReceiptResults'
                        },
                        {
                            name: 'receiptInformation'
                        },
                        {
                            name: 'wifiReceiptInformation'
                        }
                    ]);
                });
            }

            return templates;
        }();

        self.getReceipt = function(templateId, data) {
            self.toggleViews('#' + templateId, '#aa-receiptInformation');
            self.handlebarWorker.parseHandlebarsTemplate([
                {
                    name: 'receiptInformation',
                    data: data
                }
            ]);
        };

        self.getWifiReceipt = function(templateId, data) {
            self.toggleViews('#' + templateId, '#aa-wifiReceiptInformation');
            self.handlebarWorker.parseHandlebarsTemplate([
                {
                    name: 'wifiReceiptInformation',
                    data: data
                }
            ]);
        };

        self.collectFormData = function(fields) {
            var data = {};
            for(var i = 0; i < fields.length; i++) {
                var $item = $j(fields[i]);
                data[$item.attr('name')] = $item.val();
            }
            return data;
        };

        self.resetForm = function() {
            $j('[data-reset-form]').each(function(index, element) {
                var reset = $j(this).data('resetForm');
                switch (reset) {
                    case 'is-error':
                        $j(this).removeClass(reset);
                        break;
                    case 'hidden':
                        $j(this).parent().addClass(reset);
                        break;
                    case 'hide':
                        $j(this).hide();
                        break;
                    case 'empty':
                        $j(this).text('');
                        break;
                    case 'remove':
                        $j(this).remove();
                        break;
                    case 'false':
                        $j(this).val(false);
                        break;
                    default:
                        break;
                }
            });
        };

        self.getResults = function(formId) {
            self.resetForm();
            var $form = $j('#' + formId);
            var formInputs = $form.find('input');

            AAUI.ajaxRequest({
                url: $form.attr('action'),
                type: 'POST',
                data: self.collectFormData(formInputs),
                dataType: 'JSON',
                timeout: 60000,
                busyContainer: $j('body'),
                busyMessage: AAUI.getProperty('loadingTxt'),
                onSuccess: function(response, status) {
                    if(status === 'success') {
                        var data = response;
                        if(response.error) {
                            self.addToWebAnalytics('help_onboard_receipt_search_status', 'Failure');
                            if(response.showFlightNumber) {
                                var flightNumberSpan = $j('label[name="flightNumber"]').closest('.hidden');
                                flightNumberSpan.removeClass('hidden');
                                flightNumberSpan.closest('.hidden').removeClass('hidden');
                                $j('#flightNumberRequired').val(response.showFlightNumber);
                            }

                            if(response.errcode) {
                                var errorHeader = '<div class="message-error" data-reset-form="remove"><h2 class="header">' +
                                    response.errcode + '</h2></div>';
                                $j('#main h1').after(errorHeader);
                                self.addToWebAnalytics('error_id', response.errorNumber);
                            }
                            self.reportToWebAnalytics();
                            if(response.formErrors) {
                                $j.each(response.formErrors, function(key, error) {
                                    var errorSpan = $j('#' + key + '\\.error');
                                    errorSpan.text(error);
                                    console.log(errorSpan.text(error));

                                    var errorLabel = $j('label[name="' + key + '"]');
                                    errorLabel.addClass('is-error');
                                });
                            }
                        }else{
                            self.addToWebAnalytics('help_onboard_receipt_search_status', 'Success');
                            var $flightNumber = $j('#flightNumber').val();
                            if($flightNumber && ($flightNumber != "")) {
                                self.addToWebAnalytics('help_onboard_receipt_search_flight', $flightNumber);
                            }
                            self.reportToWebAnalytics();
                            $j('#flightNumberRequired').val(false);
                            self.receipts = data.receipts;
                            self.wifiReceipts = data.wifiReceipts;
                            self.handlebarWorker.parseHandlebarsTemplate([
                                {
                                    name: 'receiptResults',
                                    data: {
                                        receipts: data.receipts
                                    }
                                },

                                {
                                    name: 'wifiReceiptResults',
                                    data: {
                                        wifiReceipts: data.wifiReceipts
                                    }
                                }
                            ]);
                        }
                    }
                },
                onComplete: function(response) {
                    $j('#receiptsSearchSubmit').focus();
                    $j('#flightNumber').val('');
                    if(response.responseJSON.receipts.length) {
                        $j('#aa-receiptResults').show();
                    }
                    if(response.responseJSON.wifiReceipts.length) {
                        $j('#aa-wifiReceiptResults').show();
                    }
                    if(response.responseJSON.errcode) {
                        $j('.message-error > h2').attr('tabindex', -1).focus();
                    }
                }
            });
        };

        return self;
    };

    AAUI.datePicker = function() {
        var self = {};
        self.init = function() {
            AAUI.initDatePicker('.aaDatePicker', {
                minDate: -180,
                maxDate: 0,
                onSelect: function(currentDate, event) {
                    var today = new Date();
                    var date = $j.datepicker.parseDate($j.datepicker._defaults.dateFormat, currentDate, event.settings);
                    var $toDate = $j('#toDate');
                    switch (event.id) {
                        case 'fromDate':
                            if($toDate.datepicker('getDate') < $j('#' + event.id).datepicker('getDate')) {
                                $toDate.datepicker('setDate', null);
                            }
                            $toDate.datepicker('option', 'minDate', date);
                            AAUI.initDatepickerA11Y();
                            $j('.aaDatePicker').datepicker('refresh');
                            break;
                        case 'toDate':
                            $j('.aaDatePicker').datepicker('refresh');
                            break;
                    }
                }
            });

            self.setDefaultDates();
        };

        self.setDefaultDates = function() {
            var currentDate = new Date();
            var previousDate = new Date();
            previousDate.setDate(currentDate.getDate() - 30);
            $j('#fromDate').datepicker('setDate', previousDate);
            $j('#toDate').datepicker('setDate', currentDate);
        };

        return self;
    };

    AAUI.initPage = function(pageLoad) {
        pageLoad = pageLoad || false;
        if(pageLoad) {
            AAUI.inputCharChecker().charChecker('#last4Digits');
            AAUI.inputCharChecker().charChecker('#lastName');
            AAUI.inputCharChecker().charChecker('#flightNumber');
            AAUI.retrieveReceipts().init();
            AAUI.datePicker().init();
        }
    };

    $j(document).ready(function() {
        AAUI.initPage(true);
    });
});
